/**
 * Calculates the check digit for a given register number and transaction ID.
 * @param registerNumber The register number.
 * @param transactionId The transaction ID. * IT MUST BE 4 DIGITS LONG * from testing this seems to be the case
 * @returns The calculated check digit.
 */
export var calculateCheckDigit = function (registerNumber, transactionId) {
    var paddedTransactionId = transactionId.padStart(4, '0');
    var value = "0".concat(registerNumber).concat(paddedTransactionId, "0");
    // accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(value))
        return '';
    // The Luhn Algorithm to calculate the check digit
    var checkDigit = 0;
    var digit = 0;
    var isEven = false;
    value = value.replace(/\D/g, '');
    for (var n = value.length - 1; n >= 0; n -= 1) {
        digit = parseInt(value.charAt(n), 10); // Ensure digit is a number
        if (isEven) {
            digit *= 2;
            if (digit > 9) {
                digit -= 9;
            }
        }
        checkDigit += digit;
        isEven = !isEven;
    }
    checkDigit %= 10;
    if (checkDigit !== 0)
        checkDigit = 10 - checkDigit;
    return checkDigit.toString();
};
/**
 * Extracts receipt info from a Home Depot receipt string.
 * @param receiptText - Raw receipt text
 * @returns Receipt number in the format: STORE-REGISTER-TRANSACTION-CHECKDIGIT
 */
export var extractReceiptNumber = function (receiptText) {
    // Match a line with store, register, transaction, date, and some other number
    var match = receiptText.match(/(\d{4})\s+(\d{2,5})\s+(\d{4,6})/);
    if (!match)
        return null;
    var registerNumber = match[2];
    var transactionId = match[3];
    // Format as needed (e.g., with hyphens)
    return "".concat(registerNumber.padStart(5, '0'), "-").concat(transactionId.padStart(5, '0'));
};
